export const RouteNames = {
  Login: '/login',
  Dashboard: '/dashboard',
  Applicants: '/applicants',
  Societies: '/societies',
  Student: '/:universityName/students',
  StudentDetails: '/students',
  ConfirmUser: '/ConfirmUser'
};
